import React from 'react';
import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { ErrorType, ErrorTypeDesc } from '@/components/error/enum';

export interface Props {
  type?: ErrorType;
}

export const Error = (props: Props) => {
  const type = props.type || ErrorType.error;
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (type === ErrorType.noPermission) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          minHeight: '400px',
        }}
      >
        <Result
          status="403"
          title="403"
          subTitle={t('error.403')}
          extra={
            <Button type="primary" onClick={() => navigate(-1)}>
              {t('error.goBack')}
            </Button>
          }
        />
      </div>
    );
  }

  if (type === ErrorType.pageNotFound) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          minHeight: '400px',
        }}
      >
        <Result
          status="404"
          title="404"
          subTitle={t('error.404')}
          extra={
            <Button type="primary" onClick={() => navigate(-1)}>
              {t('error.goBack')}
            </Button>
          }
        />
      </div>
    );
  }

  return <div>{ErrorTypeDesc[type]()}</div>;
};
